<template>
  <!-- 表单样式  如果有温馨提示才加  with-warm-tip， 没有则不加 -->
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="el-form-wrap">
    <ykc-form-item label="广告名称" prop="name">
      <ykc-input v-model="ruleForm.name" maxlength="50" :placeholder="'请输入名称'"></ykc-input>
    </ykc-form-item>

    <ykc-form-item label="广告位置" prop="launchType">
      <ykc-dropdown
        placeholder="请选择广告位置"
        :clearable="false"
        :data="dictionary.launchType"
        v-model="ruleForm.launchType"></ykc-dropdown>
    </ykc-form-item>

    <ykc-form-item
      prop="image"
      label="广告图片"
      class="file-error img-error"
      bottomTip="温馨提示：请上传大小1M，尺寸750pxx1334px的jpg、jepg、png图片">
      <div class="flex upload-img-box">
        <ykc-upload ref="adsImg" @handleChange="uploadAd"></ykc-upload>
      </div>
    </ykc-form-item>

    <ykc-form-item prop="launchTerminalType" label="投放终端">
      <el-checkbox-group v-model="launchTerminalType2" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="item in launchTerminalType" :label="item.id" :key="item.id">
          {{ item.name }}
        </el-checkbox>
      </el-checkbox-group>
    </ykc-form-item>

    <ykc-form-item
      label="客户端跳转"
      prop="appSkipType"
      v-if="ruleForm.launchTerminalType.indexOf('1') > -1 && ruleForm.launchType != 2">
      <ykc-radio :data="dictionary.skipType" v-model="ruleForm.appSkipType"></ykc-radio>
    </ykc-form-item>

    <ykc-form-item
      label="跳转地址"
      prop="appSkipUrl"
      v-if="ruleForm.appSkipType === '2' && ruleForm.launchType != 2">
      <ykc-input v-model="ruleForm.appSkipUrl" :placeholder="'请输入跳转地址'"></ykc-input>
    </ykc-form-item>

    <ykc-form-item
      label="微信跳转"
      prop="wechatSkipType"
      v-if="ruleForm.launchTerminalType.indexOf('2') > -1 && !noSkip.includes(ruleForm.launchType)">
      <ykc-radio :data="dictionary.wechatSkipType" v-model="ruleForm.wechatSkipType"></ykc-radio>
    </ykc-form-item>

    <ykc-form-item
      label="链接地址"
      prop="wechatSkipUrl"
      v-if="ruleForm.wechatSkipType === '2' && !noSkip.includes(ruleForm.launchType)">
      <ykc-input v-model="ruleForm.wechatSkipUrl" :placeholder="'请输入链接地址'"></ykc-input>
    </ykc-form-item>

    <ykc-form-item
      label="APP_编码"
      prop="wechatAppId"
      v-if="ruleForm.wechatSkipType === '3' && !noSkip.includes(ruleForm.launchType)">
      <ykc-input v-model="ruleForm.wechatAppId" :placeholder="'请输入链接地址'"></ykc-input>
    </ykc-form-item>

    <ykc-form-item
      label="页面地址"
      prop="wechatSkipUrl"
      v-if="
        (ruleForm.wechatSkipType === '3' || ruleForm.wechatSkipType === '4') &&
        !noSkip.includes(ruleForm.launchType)
      ">
      <ykc-input v-model="ruleForm.wechatSkipUrl" :placeholder="'请输入链接地址'"></ykc-input>
    </ykc-form-item>

    <ykc-form-item label="投放日期" prop="launchTime">
      <ykc-date-picker
        limitDate="limitBefore"
        format="yyyy-MM-dd"
        @input="dateChange"
        v-model="launchTime"></ykc-date-picker>
    </ykc-form-item>

    <!-- 添加地理位置维度选择 -->
    <ykc-form-item label="地理位置维度" prop="geographyType" v-if="showGeographyScope">
      <ykc-radio
        :data="[
          { id: 0, name: '城市' },
          { id: 1, name: '全国' },
        ]"
        v-model="ruleForm.geographyType"
        @change="changeGeoScope"></ykc-radio>
    </ykc-form-item>

    <ykc-form-item
      prop="cityIds"
      label="选择城市"
      v-if="showGeographyScope && ruleForm.geographyType === 0">
      <ykc-cascader
        ref="addressPicker"
        :options="addressData"
        placeholder="请选择城市"
        collapseTags
        :configSet="{
          value: 'id',
          label: 'name',
          children: 'subNodes',
          multiple: true,
        }"
        v-model="ruleForm.cityIds"></ykc-cascader>
    </ykc-form-item>

    <ykc-form-item label="用户维度" prop="userScopeType">
      <ykc-radio
        :data="dictionary.userScopeType"
        @change="groupChange"
        v-model="ruleForm.userScopeType"></ykc-radio>
    </ykc-form-item>

    <ykc-form-item prop="orgList" label="发放用户" v-if="ruleForm.userScopeType === '1'">
      <ykc-tree
        ref="treeUser"
        :data="usersData"
        :props="userProps"
        @check-change="handleUsersTree" />
    </ykc-form-item>

    <ykc-form-item prop="groupList" label="发放用户" v-if="ruleForm.userScopeType === '2'">
      <ykc-tree
        ref="treeUserGroup"
        :data="userGroupData"
        :props="userGroupProps"
        @check-change="handleUsersGroupTree" />
    </ykc-form-item>

    <!-- 投放电站 - 仅在特定广告位置下显示 -->
    <template v-if="showStationScope">
      <!-- 可用维度 -->
      <ykc-form-item prop="stationScopeType" label="投放电站" required>
        <ykc-radio
          :data="dicStationScopes"
          v-model="ruleForm.stationScopeType"
          @change="changeAvailable"></ykc-radio>
      </ykc-form-item>

      <!-- 按城市选择 -->
      <ykc-form-item
        prop="stationcityIds"
        label="选择电站"
        v-if="ruleForm.stationScopeType === '1'">
        <ykc-tree
          ref="stationCityTree"
          :data="stationCityData"
          :props="stationProps"
          @check-change="handleStationCityTree"></ykc-tree>
      </ykc-form-item>

      <!-- 按商户选择 -->
      <ykc-form-item
        prop="stationList"
        label="选择电站"
        v-else-if="ruleForm.stationScopeType === '2'">
        <ykc-tree
          ref="stationTree"
          :data="stationData"
          :props="stationProps"
          @check-change="handleStationTree"></ykc-tree>
      </ykc-form-item>

      <!-- 按电站分组选择 -->
      <ykc-form-item
        prop="stationGroupList"
        label="选择电站"
        v-else-if="ruleForm.stationScopeType === '3'">
        <ykc-tree
          ref="stationGroupTree"
          :data="stationGroupData"
          :props="stationProps"
          @check-change="handleStationGroupTree"></ykc-tree>
      </ykc-form-item>
    </template>
  </ykc-form>
</template>

<script>
  import regexpObj from '@/utils/regexp';
  import { sessionGetItem } from '@/utils';
  import { getListNameById } from '@/utils/index';
  import { adsApi, uploadUtils, treeUtils, stationLabelApi } from '@/service/apis';

  export default {
    props: {
      active: {
        type: Number,
        default: 0,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: Number,
      },
    },
    components: {},
    data() {
      return {
        usersData: [],
        userGroupData: [],
        userProps: {
          label: 'name',
          children: 'subNodes',
          disabled: 'disabled',
        },
        userGroupProps: {
          label: 'name',
          children: 'subNodes',
          disabled: 'disabled',
        },
        // 电站相关数据
        stationData: [],
        stationCityData: [],
        stationGroupData: [],
        stationProps: {
          label: 'name',
          children: 'subNodes',
          disabled: 'disabled',
        },
        // 地理位置相关数据
        addressData: [], // 城市数据
        launchTime: [],
        contractList: [],
        powerStationIdList: [],
        rangeValue: [],
        activeId: '',
        noSkip: ['2', '5'],
        launchTerminalType2: [],
        launchTerminalType: [
          { id: '1', name: '客户端APP' },
          { id: '2', name: '微信小程序' },
        ],
        dictionary: {
          launchType: [
            { id: '1', name: '首页弹屏' },
            { id: '4', name: '电站列表' },
            { id: '2', name: '启动页' },
            // { id: '3', name: '电站详情' },
            { id: '8', name: '首页banner' },
            { id: '5', name: '开始充电' },
            { id: '9', name: '开始充电-弹窗' },
            { id: '6', name: '实时订单' },
            { id: '7', name: '个人中心' },
          ],
          userScopeType: [
            { id: '1', name: '按客户' },
            { id: '2', name: '按用户分组' },
            { id: '3', name: '全部' },
          ],

          skipType: [
            { id: '1', name: '不跳转' },
            { id: '2', name: '外部链接' },
          ],
          wechatSkipType: [
            { id: '1', name: '不跳转' },
            { id: '2', name: '外部链接' },
            { id: '3', name: '外部小程序' },
            { id: '4', name: '内部小程序' },
          ],
        },
        ruleForm: this.createRuleForm(),
        rules: {
          name: [
            { required: true, message: '请输入广告名称', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.inlineTextType.regexp,
              message: regexpObj.regexp.input.inlineTextType.errorTips.error('广告名称'),
            },
          ],
          launchType: [{ required: true, message: '请选择广告位置', trigger: 'blur' }],
          image: [{ required: true, message: '请选择广告图片', trigger: 'blur' }],
          launchTerminalType: [{ required: true, message: '请选择投放终端', trigger: 'blur' }],
          appSkipType: [{ required: true, message: '请选择客户端跳转', trigger: 'blur' }],
          appSkipUrl: [{ required: true, message: '请输入客户端跳转地址', trigger: 'blur' }],
          wechatSkipType: [{ required: true, message: '请选择微信跳转', trigger: 'blur' }],
          wechatSkipUrl: [{ required: true, message: '请输入页面跳转路径', trigger: 'blur' }],
          wechatAppId: [{ required: true, message: '请输入小程序appId', trigger: 'blur' }],
          launchTime: [{ required: true, message: '请选择投放日期', trigger: 'blur' }],
          userScopeType: [{ required: true, message: '请选择用户维度', trigger: 'blur' }],
          orgList: [{ required: true, message: '请选择发放用户', trigger: 'blur' }],
          groupList: [{ required: true, message: '请选择发放用户', trigger: 'blur' }],
          stationScopeType: [{ required: true, message: '请选择可用维度', trigger: 'change' }],
          stationList: [{ required: true, message: '请选择电站', trigger: 'change' }],
          stationcityIds: [{ required: true, message: '请选择电站', trigger: 'change' }],
          stationGroupList: [{ required: true, message: '请选择电站', trigger: 'change' }],
          cityIds: [{ required: true, message: '请选择城市', trigger: 'change' }], // 城市id列表
        },
      };
    },
    watch: {
      // 监听广告位置变化，动态加载电站数据
      'ruleForm.launchType': {
        handler(newVal) {
          if (this.showStationScope) {
            this.loadStationData();
          }
        },
      },
    },
    computed: {
      // 是否显示电站范围选择，仅在特定广告位置下显示
      showStationScope() {
        const stationRelatedTypes = ['5', '9', '6']; // 开始充电、开始充电-弹窗、实时订单
        return stationRelatedTypes.includes(this.ruleForm.launchType);
      },
      // 是否显示地理位置维度，仅在特定广告位置下显示
      showGeographyScope() {
        // 首页弹屏、电站列表、开始充电、实时订单、个人中心
        const geographyRelatedTypes = ['1', '4', '7'];
        return geographyRelatedTypes.includes(this.ruleForm.launchType);
      },
      /**
       * 电站维度选项
       */
      dicStationScopes() {
        return [
          { id: '1', name: '按城市选择' },
          { id: '2', name: '按商户选择' },
          { id: '3', name: '按电站分组' },
          { id: '4', name: '全部电站' }, // 注释掉全部电站选项，保持与充电任务一致
        ];
      },
      formData() {
        const formData = {
          id: this.id || '',
          name: this.ruleForm.name,
          launchType: this.ruleForm.launchType,
          image: this.ruleForm.image, // 图片
          launchTerminalType: this.ruleForm.launchTerminalType,

          appSkipType: this.ruleForm.appSkipType,
          appSkipUrl: this.ruleForm.appSkipUrl,
          wechatAppId: this.ruleForm.wechatAppId,
          wechatSkipType: this.ruleForm.wechatSkipType,
          wechatSkipUrl: this.ruleForm.wechatSkipUrl,
          launchBeginTime: `${this.launchTime[0]} 00:00:00`,
          launchEndTime: `${this.launchTime[1]} 00:00:00`,
          launchTime: this.launchTime,
          userScopeType: this.ruleForm.userScopeType,
          orgList: this.ruleForm.orgList?.filter(item => item !== null),
          groupList: this.ruleForm.groupList?.filter(item => item !== null),
          stationScopeType: this.ruleForm.stationScopeType,
          //  list: this.ruleForm.list?.filter(item => item !== null), // 树ids
          // 添加地理位置维度数据
          geographyType: this.ruleForm.geographyType,
          cityIds:
            this.ruleForm.geographyType === 0 ? this.formatcityIds(this.ruleForm.cityIds) : [],
        };
        if (this.noSkip.includes(formData.launchType)) {
          delete formData.appSkipType;
          delete formData.appSkipUrl;
          delete formData.wechatSkipType;
          delete formData.wechatSkipUrl;
        }
        if (formData.launchType === '5') {
          formData.wechatSkipType = '1';
        }

        formData.list = this.ruleForm.list?.filter(item => item !== null);
        if (!formData.list) {
          formData.list = this.ruleForm.orgList?.filter(item => item !== null);
        }

        // 添加电站范围数据（根据项目规范，统一使用stationIdList字段）
        if (this.showStationScope) {
          // 根据不同维度获取选中的电站ID
          let selectedStationIds = [];
          if (this.ruleForm.stationScopeType === '2') {
            selectedStationIds = this.ruleForm.stationList?.filter(item => item !== null) || [];
          } else if (this.ruleForm.stationScopeType === '3') {
            selectedStationIds =
              this.ruleForm.stationGroupList?.filter(item => item !== null) || [];
          } else if (this.ruleForm.stationScopeType === '1') {
            selectedStationIds = this.ruleForm.stationcityIds?.filter(item => item !== null) || [];
          }

          // 统一使用stationIdList字段传递电站ID数组
          formData.stationIdList = selectedStationIds;
        }

        return formData;
      },
    },
    created() {
      if (this.isEdit) {
        adsApi
          .detail({
            id: this.id,
          })
          .then(res => {
            this.image = res.image;
            const startTime = res.launchBeginTime.substring(0, 10);
            const endTime = res.launchEndTime.substring(0, 10);
            this.launchTime = [startTime, endTime];
            res.launchTime = [startTime, endTime];
            this.launchTerminalType2 = res.launchTerminalType?.split(',') || [];
            this.$refs.adsImg.fileList = [{ url: res.image }];
            this.ruleForm = this.createRuleForm(res);

            this.ruleForm.geographyType = res.geographyType;
            if (res.geographyType === 0 && res.cityIds.length > 0) {
              this.ruleForm.cityIds = this.formatCityList(res.cityIds);
            }
          });
      }
      const operatorId = sessionGetItem('accountId');
      const requests = [];

      // 用户相关数据请求
      const userTreeRequest = treeUtils.getAllOrgInfoGroupByTypeWithOutZdl({});
      const userTreeGroupRequest = treeUtils.operatorUserGroup({ operatorId });
      requests.push(userTreeRequest);
      requests.push(userTreeGroupRequest);

      // 获取城市数据
      const cityRequest = treeUtils.getDistrict({ level: '3' });
      requests.push(cityRequest);

      Promise.all(requests).then(([usersData, userGroup, cityData]) => {
        this.formatUserTreeData(usersData);
        this.formatUserGroupTreeData(userGroup);
        // 格式化城市数据
        if (cityData) {
          this.addressData = cityData.districts || [];
        }
        this.selectedTreesNodes(); // 填充选择内容
      });
      // 编辑模式下加载电站数据
      if (this.showStationScope) {
        this.$nextTick(() => {
          this.loadStationData();
        });
      }
    },
    methods: {
      getListNameById,
      createRuleForm(initValue = {}) {
        return {
          id: null,
          name: '',
          launchType: '',
          status: '',
          statusMean: '',
          image: '',
          launchTerminalType: '',
          launchTerminalTypeMean: '',
          appSkipType: '',
          appSkipTypeMean: '',
          appSkipUrl: '',
          wechatSkipType: null,
          wechatSkipTypeMean: null,
          wechatAppId: null,
          wechatSkipUrl: null,
          stationList: [],
          stationcityIds: [],
          stationGroupList: [],
          stationIdList: [], // 添加这个字段以避免访问未定义的属性
          stationScopeType: '4', // 默认按城市选择
          groupList: [],
          orgList: [],
          launchTime: '',
          launchBeginTime: '',
          launchEndTime: '',
          userScopeType: '3',
          userScopeTypeMean: '全部用户',
          createdName: 'admin',
          modifiedName: 'admin',
          list: null,
          // 添加地理位置维度相关字段
          geographyType: 1, // 默认全国
          cityIds: [], // 城市id列表
          ...initValue,
        };
      },
      // 格式化城市列表数据（用于编辑回显）
      formatcityIds(cityIds) {
        console.log('formatcityIds', cityIds);
        return cityIds.map(item => item[1]);
      },
      formatCityList(cityList) {
        return cityList.map(item => [item.provinceId, item.cityId]);
      },
      // 地理位置维度改变事件
      changeGeoScope() {
        // 清空已选择的城市
        this.ruleForm.cityIds = [];
      },
      uploadAd(file, fileList, isCheck) {
        if (isCheck) {
          const formData = new FormData();
          const param = {
            file: file.raw,
            bizName: '',
          };
          // 处理入参格式
          Object.entries(param).forEach(([k, v]) => {
            formData.append(k, v);
          });
          uploadUtils.uploadImg(formData).then(res => {
            this.ruleForm.image = res;
          });
        }
      },
      formatUserTreeData(data) {
        if (data) {
          this.usersData = [];
          if (data) {
            let id = 1000000;
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, users] of Object.entries(data)) {
              const user = {
                id: id++,
                name: key,
                subNodes: [],
                disabled: false,
              };
              users.forEach(item => {
                user.subNodes.push({
                  id: item.id,
                  name: item.name,
                });
              });
              this.usersData.push(user);
            }
          }
        }
      },
      formatUserGroupTreeData(data) {
        this.userGroupData = [];
        if (data?.length > 0) {
          data.forEach(item => {
            const userGroup = {
              id: item.id,
              name: item.groupName || '未知',
              disabled: false,
            };
            this.userGroupData.push(userGroup);
          });
        }
      },
      // 加载电站相关数据
      loadStationData() {
        const requests = [];

        // 商户电站数据
        const stationTreeRequest = treeUtils.operatorStations({});
        // 城市电站数据
        const stationCityTreeRequest = treeUtils.findCityStationTree({});
        // 电站分组数据（根据项目规范，使用stationLabelApi.queryStationTree）
        const stationGroupTreeRequest = stationLabelApi.queryStationTree({});

        requests.push(stationTreeRequest);
        requests.push(stationCityTreeRequest);
        requests.push(stationGroupTreeRequest);

        Promise.all(requests).then(([stationData, stationCityData, stationGroupData]) => {
          // 格式化电站相关数据
          if (stationData) this.formatStationTreeData(stationData);
          if (stationCityData) this.formatStationCityTreeData(stationCityData);
          if (stationGroupData) this.formatStationGroupTreeData(stationGroupData);

          // 编辑模式下回显已选择的数据
          if (this.isEdit) {
            this.selectedTreesNodes();
          }
        });
      },
      // 格式化商户电站树数据
      formatStationTreeData(data) {
        this.stationData = [];
        if (data?.length > 0) {
          data.forEach(item => {
            const station = {
              id: `0${item.operatorId}`,
              name: item.operatorName || '未知',
              subNodes: [],
              disabled: false,
            };
            if (item?.stationTreeVOList?.length > 0) {
              item.stationTreeVOList.forEach(item1 => {
                const subNode = { id: item1.stationId, name: item1.stationName, disabled: false };
                station.subNodes.push(subNode);
              });
            }
            this.stationData.push(station);
          });
        }
      },
      // 格式化城市电站树数据
      formatStationCityTreeData(originData) {
        // 转换省市区为data-picker数据
        function transPCDItem(item) {
          const subNodes = [];
          if (item.subTree) {
            item.subTree.forEach(itm => {
              subNodes.push(transPCDItem(itm));
            });
          }
          const obj = {
            id: item.id,
            name: item.name || '未知',
            subNodes,
            disabled: false,
          };
          return obj;
        }

        function transPCD(data) {
          if (!data || !data.length) {
            return [];
          }
          const result = [];
          data.forEach(item => {
            result.push(transPCDItem(item));
          });
          return result;
        }

        this.stationCityData = transPCD(originData);
      },
      // 格式化电站分组数据（根据项目规范进行格式化）
      formatStationGroupTreeData(data) {
        this.stationGroupData = [];
        if (data?.length > 0) {
          data.forEach(item => {
            // 根据项目规范，使用name字段和subNodes: item.subTree || []
            const stationGroup = {
              id: item.id,
              name: item.name || '未知',
              subNodes: item.subTree || [],
              disabled: false,
            };
            if (item?.childList?.length > 0) {
              item.childList.forEach(item1 => {
                const subNode = { id: item1.id, name: item1.name, disabled: false };
                stationGroup.subNodes.push(subNode);
              });
            }
            this.stationGroupData.push(stationGroup);
          });
        }
      },
      handleCheckedCitiesChange(e) {
        if (e.length > 1) {
          this.ruleForm.launchTerminalType = `${e[0]},${e[1]}`;
        } else if (e.length === 1) {
          // eslint-disable-next-line prefer-destructuring
          this.ruleForm.launchTerminalType = e[0];
        } else {
          this.ruleForm.launchTerminalType = '';
        }
      },
      groupChange(e) {
        if (e === '1') {
          if (this.ruleForm.orgList?.length > 0) {
            this.$nextTick(() => {
              if (this.$refs.treeUser) {
                if (this.$refs.treeUser)
                  this.$refs.treeUser.setCheckedKeys(this.ruleForm.orgList, true);
              }
            });
          }
        } else if (e === '2') {
          if (this.ruleForm.groupList?.length > 0) {
            this.$nextTick(() => {
              if (this.$refs.treeUserGroup) {
                if (this.$refs.treeUserGroup)
                  this.$refs.treeUserGroup.setCheckedKeys(this.ruleForm.groupList, true);
              }
            });
          }
        }
      },
      handleUsersTree() {
        if (this.$refs.treeUser) {
          this.ruleForm.orgList =
            (this.$refs.treeUser && this.$refs.treeUser.getCheckedKeys(true)) || [];
          this.ruleForm.list =
            (this.$refs.treeUser && this.$refs.treeUser.getCheckedKeys(true)) || [];
        }
      },
      handleUsersGroupTree() {
        if (this.$refs.treeUserGroup) {
          this.ruleForm.groupList =
            (this.$refs.treeUserGroup && this.$refs.treeUserGroup.getCheckedKeys(true)) || [];
          this.ruleForm.list =
            (this.$refs.treeUserGroup && this.$refs.treeUserGroup.getCheckedKeys(true)) || [];
        }
      },
      // 电站树选择事件
      handleStationTree() {
        if (this.$refs.stationTree) {
          this.ruleForm.stationList =
            (this.$refs.stationTree && this.$refs.stationTree.getCheckedKeys(true)) || [];
        }
      },
      handleStationCityTree() {
        if (this.$refs.stationCityTree) {
          this.ruleForm.stationcityIds =
            (this.$refs.stationCityTree && this.$refs.stationCityTree.getCheckedKeys(true)) || [];
        }
      },
      handleStationGroupTree() {
        if (this.$refs.stationGroupTree) {
          this.ruleForm.stationGroupList =
            (this.$refs.stationGroupTree && this.$refs.stationGroupTree.getCheckedKeys(true)) || [];
        }
      },
      dateChange(e) {
        console.log(JSON.stringify(e));
        this.launchTime = e;
        this.ruleForm.launchTime = e;
      },
      selectedTreesNodes() {
        if (this.ruleForm?.id) {
          // 第一次加载的时候回显
          if (this.ruleForm.userScopeType === '1' && this.ruleForm.orgList?.length > 0) {
            this.$nextTick(() => {
              if (this.$refs.treeUser) {
                this.$refs.treeUser.setCheckedKeys(this.ruleForm.orgList, true);
              }
            });
          } else if (this.ruleForm.userScopeType === '2' && this.ruleForm.groupList?.length > 0) {
            // 分组
            this.$nextTick(() => {
              if (this.$refs.treeUserGroup) {
                this.$refs.treeUserGroup.setCheckedKeys(this.ruleForm.groupList, true);
              }
            });
          }

          // 电站范围回显
          if (this.showStationScope) {
            if (this.ruleForm.stationScopeType === '2' && this.ruleForm.stationIdList?.length > 0) {
              this.$nextTick(() => {
                this.ruleForm.stationList = this.fillTreeSelectedIds(this.ruleForm.stationIdList);
                this.$refs.stationTree.setCheckedKeys(this.ruleForm.stationList, true);
              });
            } else if (
              this.ruleForm.stationScopeType === '3' &&
              this.ruleForm.stationIdList?.length > 0
            ) {
              this.$nextTick(() => {
                this.ruleForm.stationGroupList = this.fillTreeSelectedIds(
                  this.ruleForm.stationIdList
                );
                this.$refs.stationGroupTree.setCheckedKeys(this.ruleForm.stationGroupList, true);
              });
            } else if (
              this.ruleForm.stationScopeType === '1' &&
              this.ruleForm.stationIdList?.length > 0
            ) {
              this.$nextTick(() => {
                this.ruleForm.stationcityIds = this.fillTreeSelectedIds(
                  this.ruleForm.stationIdList
                );
                this.$refs.stationCityTree.setCheckedKeys(this.ruleForm.stationcityIds, true);
              });
            }
          }
        }
      },
      /**
       * 选择树形控件
       * @param tree
       * @param selectedNodes
       */
      selectTreeNodes(tree, selectedNodes) {
        this.$nextTick(() => {
          tree.setCheckedKeys(selectedNodes, true);
        });
      },
      fillTreeSelectedIds(records) {
        const selectedIds = [];
        records.forEach(item => {
          selectedIds.push(parseInt(item, 10));
        });
        return selectedIds;
      },
      changeStation(val) {
        const item = this.powerStationIdList.find(o => o.stationId === val);
        this.ruleForm.operatorName = item?.operatorName ?? '';
        this.ruleForm.operatorAttribute = item?.operatorAttribute ?? '';
        this.ruleForm.stationStatusCode = item?.stationStatusCode ?? '';
      },
      // 清空电站选择数据
      changeAvailable() {
        this.ruleForm.stationList = [];
        this.ruleForm.stationcityIds = [];
        this.ruleForm.stationGroupList = [];

        // 清除各个树的选中状态
        this.$nextTick(() => {
          if (this.$refs.stationTree) {
            this.$refs.stationTree.setCheckedKeys([], false);
          }
          if (this.$refs.stationCityTree) {
            this.$refs.stationCityTree.setCheckedKeys([], false);
          }
          if (this.$refs.stationGroupTree) {
            this.$refs.stationGroupTree.setCheckedKeys([], false);
          }
        });
      },
      submitForm() {
        console.log(JSON.stringify(this.formData));
        return new Promise(resolve => {
          this.validateForm().then(() => {
            if (this.isEdit) {
              adsApi.edit(this.formData).then(() => {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                });
                resolve();
              });
            } else {
              adsApi.add(this.formData).then(() => {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                });
                resolve();
              });
            }
          });
        });
      },
      validateForm() {
        return new Promise((resolve, reject) => {
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  ._line {
    display: flex;
    & > * {
      margin-right: 5px;
    }
  }
</style>
